module.exports = __webpack_public_path__ + "static/media/linkedin.40ec3606.svg";